@import '../../gzNodeDirector/view/nodeShared.scss';

.rename-container {
  display: flex;
  flex-grow: 1;
  align-items: flex-start;
  justify-content: space-between;
}

.input-container {
  flex-basis: 400px;
}

.buttons-container {
  margin-top: calc(var(--spacer) / 2);
}

.node {
  padding-left: var(--spacer);
}
